import type { PromotionCreationReason } from '../PromotionCodes.types'
import { useFilterPromotionCodes } from '../modules/PromotionCodesFilter'
import { usePromotionsInfiniteQuery } from '../queries/usePromotionsInfiniteQuery'

export const usePromotionCodesInfinite = () => {
  const { filtersParams } = useFilterPromotionCodes()
  const { query: promotionsQuery } = usePromotionsInfiniteQuery(
    {
      creationReasons: (filtersParams.creationReason as PromotionCreationReason) || ['MANUAL'],
    },
    {
      keepPreviousData: true,
    },
  )

  const data = promotionsQuery.data?.pages.flatMap((page) => page.promotions) || []
  const hasNextPage = Boolean(promotionsQuery.hasNextPage)
  const fetchNextPage = promotionsQuery.fetchNextPage

  return {
    data,
    isLoading: promotionsQuery.isFetching,
    hasNextPage,
    onLoadMore: fetchNextPage,
  }
}
